export default __webpack_public_path__ + "static/media/RodandoIcon.f7ddb0a7.svg";